export const getWorkersCount = state => state.workersCount.get("count")
